<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <datatable :columns="columns" :data="table_data" >
      </datatable>
      <datatable-pager v-model="page"></datatable-pager>
    </div>
    <!-- </div> -->
  <!-- </div> -->
  </div>
</template>

<script>
  export default {
    name: 'visits-table',
    props: {
      type: {
        type: String
      },
      title: String,
      table_data : Array
    },
    
    computed:{
      
    },
    data() {
      return {
        filter: '',
        page: 1,
        columns : [{th: 'Datetime', name: 'datetime'},{th: 'Amount', name: 'amount_spent'},{th: 'Phone', name: 'phone_number'},{th: 'Points', name: 'points'},{th: 'Invoice Number', name: 'invoice_number'}, {th : 'Is Redeem', name : 'is_redeem'}, {th : 'Branch', name : 'store_id'}]
      }
    }
  }
</script>
